import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import style from '../index.module.scss'
import { getTotalItem } from '../store/slice'

export const Header = () => {
  const totalItems = useSelector(getTotalItem)

  return (
    <>
      <div
        className={['dFlex justifyContentBetween ', style.headerTitle].join(
          ' ',
        )}
      >
        <Element
          style={{
            fontSize: 24,
            fontWeight: 600,
            color: '#0553A5',
            textTransform: 'uppercase',
          }}
        >
          <Translate value="library.main.FOLLOWING_LIST" />
        </Element>
        <Element
          className={style.totalTitle}
          style={{
            backgroundColor: '#EFF3FA',
          }}
        >
          <Element
            elementName="p"
            style={{
              fontWeight: 600,
              lineHeight: '24px',
            }}
          >
            <Translate value="library.main.TOTAL_COMPANIES" />
          </Element>
          <Element
            elementName="p"
            style={{
              fontSize: 16,
              fontWeight: 600,
              lineHeight: '24px',
            }}
          >
            {totalItems || 0}
          </Element>
        </Element>
      </div>
    </>
  )
}
